/* Stylesheet */

.chart_wrapper_options {
  display: flex;
}
